import React, { useContext } from 'react'
import { Card, Form, Button, Container, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './missing-styles.css';
import { FaRegQuestionCircle, FaArrowRight } from 'react-icons/fa'; 
import { TbTruckReturn } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";
import { SlPuzzle } from "react-icons/sl";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { OrderContext } from '../../context/OrderContext';
import useStartSingleClaim from '../../hook/useStartSingleClaim';






const MissingType = () => {


    const navigate = useNavigate();

    const { missingProcess} = useContext(OrderContext);
    const {startClaim} = useStartSingleClaim()
  
    const handleNavigation = (path) => {
        navigate(path);
      };

      const handleExchange = () => {
      
        if (missingProcess) {
          navigate('/missing-summary-product');
          } else {
            startClaim("2");
            navigate('/missing-product');
        }
      };
    
      const handleMissingDelivery = () => {
       
        navigate('/missing-warning');

       
      };
    
  

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
    <Card className='card-box'> 
      <Card.Title className='card-title'>Eksik/Teslim edilmeyen sipariş</Card.Title>
      <ListGroup variant="flush">
        <p>Talep Seçiminizi Detaylandırın</p>
        

        <ListGroup.Item action onClick={handleExchange} >
            Kargom bana ulaştı ancak
             <span style={{marginRight:'3px',marginLeft:'3px', fontWeight:'bold'}}> eksik /ürün</span> 
             { missingProcess? "talebimi görüntüle" : "parçası var"}
            <IoIosArrowForward className="float-end" /> 
          </ListGroup.Item>

          <ListGroup.Item action onClick={handleMissingDelivery}>
            <span style={{marginRight:'3px', fontWeight:'bold'}}>Kargom bana ulaşmadı</span>  ancak teslim edildi görünüyor
            <IoIosArrowForward className="float-end" /> 
          </ListGroup.Item>
        
      
        </ListGroup>
        </Card>
    </Container>
  )
}

export default MissingType